export const AIAssistantQuestionTypes = {
  ASK: 'ASK',
  ASK_DOC: 'ASK_DOC',
} as const

export type AIAssistantQuestionType =
  (typeof AIAssistantQuestionTypes)[keyof typeof AIAssistantQuestionTypes]

export type AICredits = {
  remaining: number
  renewalDate?: string
  total: number
}

export type AIAssistantConversation = {
  id: string
  title: string | null
  createdAt: string
  updatedAt: string | null
  messages: Array<AIAssistantMessage>
}

export type AIAssistantConversationListData = {
  yesterday: AIAssistantConversation[]
  today: AIAssistantConversation[]
  lastSevenDays: AIAssistantConversation[]
  lastThirtyDays: AIAssistantConversation[]
  lastNinetyDays: AIAssistantConversation[]
}

export type AIAssistantConversationMessage = {
  conversationId: string
  createdAt: string
  id: string
  prompt: string
  response: string
  sources?: Array<{title: string, link: string}>
  updatedAt: string | null
  errorCode?: string
  errorMessage?: string
  isRetryable?: boolean
}

export type AIAssistantMessage = {
  id: string
  role: 'user' | 'assistant' | 'system'
  content: string
  timestamp: string
}
